import React from 'react';
import './FileManagerSkeleton.css';

const FileManagerSkeleton = ({ count = 9 }) => {
    return (
        <div>
            {/* Skeleton Header */}
            <div className="fm-skeleton-header">
                <div className="fm-skeleton-header-left">
                    <div className="fm-skeleton-back-btn" />
                    <div className="fm-skeleton-title" />
                </div>
                <div className="fm-skeleton-upload-btn" />
            </div>

            {/* Skeleton Breadcrumb */}
            <div className="fm-skeleton-breadcrumb">
                <div className="fm-skeleton-breadcrumb-item" />
            </div>

            {/* Skeleton Items Grid */}
            <div className="fm-skeleton-grid">
                {Array.from({ length: count }).map((_, index) => (
                    <div key={index} className="fm-skeleton-item">
                        <div className="fm-skeleton-icon" />
                        <div className="fm-skeleton-info">
                            <div className="fm-skeleton-name" />
                            <div className="fm-skeleton-date" />
                        </div>
                        <div className="fm-skeleton-dots" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FileManagerSkeleton;
